module.exports = __webpack_public_path__ + "static/media/Sample-Listening-Note-Completion-trimmed.87cf04f3.mp3";